import { DISPATCH_TARGET } from "../../../../shared/constants/dispatchTarget";
import DispatchList from "../../../../components/units/Management/Dispatch/List";

export default function DispatchEpTpPage() {
  return <DispatchList target={DISPATCH_TARGET.epTp} initSearchType="to" />;
}
